import RotationDial from "../../../../../../../../library/rotation-dial";
import { getIcon } from "../../../../../../../../utils/get-icon";
import { useSettings } from "../../../../context";
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  AccordionTitle,
  InnerAccordionHeader,
} from "../styled";
import ToggleButtons from "../../../../../../../../library/toggle-buttons";
import {
  DoubleCol,
  PositionInput,
  PositionInputIcon,
  PositionInputWrapper,
  FieldWrapper,
  TopWrapper,
} from "./styled";

const PositionSettings = () => {
  const {
    updatePositionSettings,
    getSelectedItemSettings,
    updateRotationSettings,
    updateAlignmentSettings,
  } = useSettings();

  const currentSettings = getSelectedItemSettings();

  const handleXChange = (e: any) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value)) {
      updatePositionSettings({ x: value });
    }
  };

  const handleYChange = (e: any) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value)) {
      updatePositionSettings({ y: value });
    }
  };

  const handleRotationChange = (value: any) => {
    updateRotationSettings({ degrees: value });
  };

  const handleVerticalAlignChange = (value: any) => {
    updateAlignmentSettings({ vertical: value });
  };

  const handleHorizontalAlignChange = (value: any) => {
    updateAlignmentSettings({ horizontal: value });
  };

  return (
    <AccordionItem key="1" eventKey="1">
      <AccordionHeader>
        <InnerAccordionHeader>
          <AccordionTitle>{getIcon("")} Posisjonering</AccordionTitle>
        </InnerAccordionHeader>
      </AccordionHeader>
      <AccordionBody>
        <TopWrapper>
          <DoubleCol>
            <PositionInputWrapper>
              <PositionInputIcon>{getIcon("position-x")}</PositionInputIcon>
              <PositionInput
                onChange={handleXChange}
                value={currentSettings.position.x}
                type="number"
              />
            </PositionInputWrapper>
            <PositionInputWrapper>
              <PositionInputIcon>{getIcon("position-y")}</PositionInputIcon>
              <PositionInput
                onChange={handleYChange}
                value={currentSettings.position.y}
                type="number"
              />
            </PositionInputWrapper>
          </DoubleCol>
        </TopWrapper>
        <RotationDial
          value={currentSettings?.rotation?.degrees}
          onChange={handleRotationChange}
        />
        <FieldWrapper>
          <ToggleButtons
            selected={currentSettings?.configuration?.alignment?.horizontal}
            className="toggle-buttons"
            options={[
              {
                title: getIcon("align-horizontal-left"),
                value: "left",
              },
              {
                title: getIcon("align-horizontal-center"),
                value: "center",
              },
              {
                title: getIcon("align-horizontal-right"),
                value: "right",
              },
            ]}
            onSelect={handleHorizontalAlignChange}
          />
        </FieldWrapper>
        <FieldWrapper>
          <ToggleButtons
            selected={currentSettings?.configuration?.alignment?.vertical}
            className="toggle-buttons"
            options={[
              {
                title: getIcon("align-vertical-top"),
                value: "flex-start",
              },
              {
                title: getIcon("align-vertical-center"),
                value: "center",
              },
              {
                title: getIcon("align-vertical-bottom"),
                value: "flex-end",
              },
            ]}
            onSelect={handleVerticalAlignChange}
          />
        </FieldWrapper>
      </AccordionBody>
    </AccordionItem>
  );
};

export default PositionSettings;
